// views/Admin/Bonuses/components/BonusForm/components/DaySelector/DaySelector.tsx
import { useState, type MouseEvent } from 'react';
import styles from './DaySelector.module.css';

const daysOfWeek = [
  { short: 'Po', full: 0 },
  { short: 'Út', full: 1 },
  { short: 'St', full: 2 },
  { short: 'Čt', full: 3 },
  { short: 'Pá', full: 4 },
  { short: 'So', full: 5 },
  { short: 'Ne', full: 6 },
];

interface DaySelectorProps {
  renewingDays: number[];
  onChange?: (days: number[]) => void;
}

export default function DaySelector({ renewingDays, onChange }: DaySelectorProps) {
  const [days, setDays] = useState<number[]>(renewingDays);

  const toggleDay = (e: MouseEvent, day: number) => {
    e.preventDefault();
    const updatedDays = days.includes(day) ? days.filter((d) => d !== day) : [...days, day];
    setDays(updatedDays);
    onChange?.(updatedDays);
  };

  return (
    <div className={styles.container}>
      {daysOfWeek.map(({ short, full }, i) => (
        <button
          key={i}
          title={String(full)}
          onClick={(e) => toggleDay(e, full)}
          className={`${styles.dayButton} ${days.includes(full) ? styles.active : ''}`}
        >
          {short}
        </button>
      ))}
    </div>
  );
}
